import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import isNotNullOrEmpty from 'utilities/is/isNotNullOrEmpty';
import Divider from '@mui/material/Divider';
import { H4, Body1 } from 'components/Typography';
import styles from './styles';
import m from 'messages';
import { toShortDateTimeString, fromFormat, DateTimeFormats } from 'utilities/formatters/dateTimeFormatter';

function Breathalyser(props) {

    const { card, classes } = props;
    const hasBreathalyserResults = isNotNullOrEmpty(card.breathalyserTestsForSite) && card.hasBreathalyserTestForSite;
    const result = hasBreathalyserResults ? card.breathalyserTestsForSite[card.breathalyserTestsForSite.length-1] : [];
    return (
        <div className={classes.fullWidth}>
            {hasBreathalyserResults &&
                <div className={classes.container}>
                    <H4 paragraph>
                        {m.cards.breathalyserHeader}
                    </H4>
                    <div className={classes.body}>
                        <Body1 paragraph>
                            {m.cards.breathalyserLastSiteTest(
                                toShortDateTimeString(
                                    fromFormat(result.testDate, DateTimeFormats.LongDateTimeFormat).toLocal()))}
                        </Body1>
                        <Divider />
                    </div>
                </div>
            }
        </div>
    );
}

Breathalyser.propTypes = {
    card: PropTypes.object.isRequired
};

export default withStyles(Breathalyser,styles);